import React from 'react';
import cn from 'classnames'
import './SectionHeader.css';

export type SectionHeaderProps = {
  content: string | React.ReactNode
  fontColor?: "white" | "base" | "link" | "black"
  fontWeight?: "bold" | "extra-bold" | "semi-bold"
  fontSize?: "tiny" | "small" | "medium" | "large"
  leftMargin?: string | number
  topMargin?: string | number
  rightMargin?: string | number
  bottomMargin?: string | number
  className?: string,
  testId?: string
  version?: string
}

const SectionHeader = (props: SectionHeaderProps) => {

  const { content, fontColor = "black", fontSize = "medium", fontWeight = "extra-bold", leftMargin, rightMargin, topMargin, bottomMargin, className, testId = "cs-section-header", version } = props || {};

  const classNames = cn('SectionHeader', className, {
    [`SectionHeader--${fontWeight}`]: fontWeight,
    [`SectionHeader--${fontSize}`]: fontSize,
    [`SectionHeader--${fontColor}`]: fontColor,
    ['SectionHeader--v2']: version === 'v2'
  })

  return (
    <div data-testid={testId} data-test-id={testId} className={classNames} style={{ marginTop: topMargin, marginBottom: bottomMargin, marginLeft: leftMargin, marginRight: rightMargin }} >
      {content}
    </div>
  );
};

export default SectionHeader;
